import QuestionVariantsWarning from "pages/QuestionPage/questionPreview/QuestionVariantsWarning/QuestionVariantsWarning";

export default QuestionVariantsWarning;
